<template>
    <div class="page">
        <el-pagination
            @size-change="sizeChange"
            @current-change="currentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="pageSize"
            background
            layout="sizes, prev, pager, next, jumper"
            :total="total"
        ></el-pagination>
    </div>
</template>
<script>
export default {
    props: {
        pageSize: {
            type: Number,
            required: true
        },
        currentPage: {
            type: Number,
            required: true
        },
        total: {
            type: Number,
            required: true
        }
    },
    methods: {
        currentChange (a) {
            this.$emit('current-change', a)
        },
        sizeChange (a) {
            this.$emit('size-change', a)
        }
    }
}
</script>
<style scoped>
.page {
    margin-top: 20px;
}
.page > div {
    float: right;
}
.page::after{
    content: '';
    display: block;
    height: 0;
    overflow: hidden;
    clear: both;
}
</style>



// WEBPACK FOOTER //
// src/components/glPage.vue